/**
 * Generates a link from a given url with a prefixed pathname of '_:'.
 *
 * @param {String} url
 * @param {Object} item
 * @return {String}
 */
export default function generateLink(url, item) {
    if (!url.match(/_:[a-z]+/g)) {
        return url;
    }

    const urlObject = new URL(url);

    const segments = urlObject.pathname.split('/').map(segment => {
        if (segment.match(/_:[a-z]+/g)) {
            const property = segment.replace('_:', '');

            if (Object.prototype.hasOwnProperty.call(item, property)) {
                return segment.replace(`_:${property}`, item[property]);
            }
        }

        return segment;
    });

    urlObject.pathname = segments.join('/');

    return urlObject.toString();
}
